import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { BLOCK_WS } from "./actionTypes";
import { blockWorkstationsSuccess, blockWorkstationsError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* blockWorkstation({ payload: { ws, token, history } }) {

  try {

    const response = yield call(workstationAPI.blockWorkstation, ws, token);
    yield put(blockWorkstationsSuccess(response.message));
    history.go()
  } catch (error) {
    yield put(blockWorkstationsError(error));
  }
}

export function* watchBlockWorkstations() {
  yield takeEvery(BLOCK_WS, blockWorkstation);
}

function* BlockWorkstationsSaga() {
  yield all([fork(watchBlockWorkstations)]);
}

export default BlockWorkstationsSaga;
